module.exports = __webpack_public_path__ + "img/box7-10.e4275e5a.png";